import Api from './baseApi';

export default {
    // Yeni canlı veri endpoint'leri
    getLiveSummary: (params) => {
        let url = '/api/reconciliation/live-summary';
        const queryParams = [];
        if (params && params.startDate) queryParams.push(`startDate=${params.startDate}`);
        if (params && params.endDate) queryParams.push(`endDate=${params.endDate}`);
        if (params && params.orderNumber) queryParams.push(`orderNumber=${encodeURIComponent(params.orderNumber)}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    },
    getLiveOrderSummary: (params) => {
        let url = '/api/reconciliation/live-order-summary';
        const queryParams = [];
        if (params && params.startDate) queryParams.push(`startDate=${params.startDate}`);
        if (params && params.endDate) queryParams.push(`endDate=${params.endDate}`);
        if (params && params.page) queryParams.push(`page=${params.page}`);
        if (params && params.pageSize) queryParams.push(`pageSize=${params.pageSize}`);
        if (params && params.orderNumber) queryParams.push(`orderNumber=${encodeURIComponent(params.orderNumber)}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    },
    recalculateAllExpectedPayments: (params) => {
        let url = '/api/reconciliation/recalculate-all';
        const queryParams = [];
        if (params && params.startDate) queryParams.push(`startDate=${params.startDate}`);
        if (params && params.endDate) queryParams.push(`endDate=${params.endDate}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.post(url);
    },
    calculateOrderExpectedPayments: (params) => {
        return Api.post(`/api/reconciliation/calculate-order/${encodeURIComponent(params.orderNumber)}`);
    },
    getLiveTransactionDetails: (params) => {
        let url = '/api/reconciliation/live-transaction-details';
        const queryParams = [];
        if (params && params.startDate) queryParams.push(`startDate=${params.startDate}`);
        if (params && params.endDate) queryParams.push(`endDate=${params.endDate}`);
        if (params && params.transactionType !== undefined && params.transactionType !== null) queryParams.push(`transactionType=${params.transactionType}`);
        if (params && params.page) queryParams.push(`page=${params.page}`);
        if (params && params.pageSize) queryParams.push(`pageSize=${params.pageSize}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    },
    getOrderBreakdown: (params) => {
        let url = '/api/reconciliation/order-breakdown';
        const queryParams = [];
        if (params && params.orderNumber) queryParams.push(`orderNumber=${encodeURIComponent(params.orderNumber)}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    },

    // Eski endpoint'ler (geriye dönük uyumluluk)
    getSummary: (params) => {
        let url = '/api/reconciliation/summary';
        const queryParams = [];
        if (params && params.startDate) queryParams.push(`startDate=${params.startDate}`);
        if (params && params.endDate) queryParams.push(`endDate=${params.endDate}`);
        if (params && params.deliveryStartDate) queryParams.push(`deliveryStartDate=${params.deliveryStartDate}`);
        if (params && params.deliveryEndDate) queryParams.push(`deliveryEndDate=${params.deliveryEndDate}`);
        if (params && params.orderStatus !== undefined && params.orderStatus !== null) queryParams.push(`orderStatus=${params.orderStatus}`);
        if (params && params.transactionType !== undefined && params.transactionType !== null) queryParams.push(`transactionType=${params.transactionType}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    },
    getDetails: (params) => {
        let url = '/api/reconciliation/details';
        const queryParams = [];
        if (params && params.startDate) queryParams.push(`startDate=${params.startDate}`);
        if (params && params.endDate) queryParams.push(`endDate=${params.endDate}`);
        if (params && params.deliveryStartDate) queryParams.push(`deliveryStartDate=${params.deliveryStartDate}`);
        if (params && params.deliveryEndDate) queryParams.push(`deliveryEndDate=${params.deliveryEndDate}`);
        if (params && params.orderStatus !== undefined && params.orderStatus !== null) queryParams.push(`orderStatus=${params.orderStatus}`);
        if (params && params.transactionType !== undefined && params.transactionType !== null) queryParams.push(`transactionType=${params.transactionType}`);
        if (params && params.page) queryParams.push(`page=${params.page}`);
        if (params && params.pageSize) queryParams.push(`pageSize=${params.pageSize}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    },
    getOrderSummary: (params) => {
        let url = '/api/reconciliation/order-summary';
        const queryParams = [];
        if (params && params.startDate) queryParams.push(`startDate=${params.startDate}`);
        if (params && params.endDate) queryParams.push(`endDate=${params.endDate}`);
        if (params && params.deliveryStartDate) queryParams.push(`deliveryStartDate=${params.deliveryStartDate}`);
        if (params && params.deliveryEndDate) queryParams.push(`deliveryEndDate=${params.deliveryEndDate}`);
        if (params && params.orderStatus !== undefined && params.orderStatus !== null) queryParams.push(`orderStatus=${params.orderStatus}`);
        if (params && params.page) queryParams.push(`page=${params.page}`);
        if (params && params.pageSize) queryParams.push(`pageSize=${params.pageSize}`);
        if (queryParams.length > 0) url += '?' + queryParams.join('&');
        return Api.get(url);
    },
    calculate: (params) => Api.post('/api/reconciliation/calculate', {
        startDate: params.startDate,
        endDate: params.endDate
    })
};
